export const manifest = {
  screens: {
    scr_tlm09i: { name: "Home", route: "/" },
  },
}
